angular.module('dnecom')
    .controller('UrlMappingModalController', ["$scope", "$uibModalInstance", function ($scope, $uibModalInstance) {
        $scope.save = function(form) {
            if (!$scope.validateForm(form)) {
                return;
            }

            $uibModalInstance.close($scope.urls);
        };

        $scope.validateForm = function(form) {
            if (form.$invalid || form.$pending) {
                form.$setTouched();
                return false;
            }

            return true;
        };

        $scope.closeModal = function () {
            $uibModalInstance.dismiss();
        };
    }]);
